import { render, staticRenderFns } from "./VatNumberBlock.vue?vue&type=template&id=b54b01c0&scoped=true"
import script from "./VatNumberBlock.vue?vue&type=script&lang=js"
export * from "./VatNumberBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b01c0",
  null
  
)

export default component.exports